/**
 * Date-extensions locale Burmese [my]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('my', {
    monthNames: ['ဇန်နဝါရီ','ဖေဖော်ဝါရီ','မတ်','ဧပြီ','မေ','ဇွန်','ဇူလိုင်','သြဂုတ်','စက်တင်ဘာ','အောက်တိုဘာ','နိုဝင်ဘာ','ဒီဇင်ဘာ'],
    monthShortNames: ['ဇန်','ဖေ','မတ်','ပြီ','မေ','ဇွန်','လိုင်','သြ','စက်','အောက်','နို','ဒီ'],
    dayNames: ['တနင်္ဂနွေ','တနင်္လာ','အင်္ဂါ','ဗုဒ္ဓဟူး','ကြာသပတေး','သောကြာ','စနေ'],
    dayShortNames: ['နွေ','လာ','ဂါ','ဟူး','ကြာ','သော','နေ']
});
